import { createSlice } from "@reduxjs/toolkit";
import { contactUsSubmit } from "./contactUsService";

export const STATUS = {
    IDLE: "idle",
    LOADING: "loading",
    SUCCEEDED: "succeeded",
    FAILED: "failed",
};

const initialState = {
    contactUs: {
        status: STATUS.IDLE,
        error: null,
        contactUsMessage: null,
    },
};

const contactUsSlice = createSlice({
    name: "contactUs",
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder
            .addCase(contactUsSubmit.pending, (state) => {
                state.contactUs.status = STATUS.LOADING;
                state.contactUs.error = null;
            })
            .addCase(contactUsSubmit.fulfilled, (state, action) => {
                state.contactUs.status = STATUS.SUCCEEDED;
                state.contactUs.contactUsMessage = action?.payload;
            })
            .addCase(contactUsSubmit.rejected, (state, action) => {
                state.contactUs.status = STATUS.FAILED;
                state.contactUs.error = action.payload?.message;
            });

    },
});

export const selectContactUs = (state) =>
    state.contactUs.contactUs;

export default contactUsSlice.reducer;
